export default __webpack_public_path__ + "static/media/vinicius.051166b9.png";